import { useEffect, useId, useRef, useState } from "react";
import Icono from "./Icono";

// Agrupa las acciones de la cuenta (Mi cuenta, PIN, cambiar de vendedor) detrás
// del nombre del vendedor, en vez de tres botones más en la barra. Es un
// popover nativo: Escape y clic afuera lo cierran sin código propio.
export default function MenuCuenta({
  nombre,
  busy,
  onPerfil,
  onPin,
  onSalir,
}: {
  nombre: string;
  busy: boolean;
  onPerfil: () => void;
  onPin: () => void;
  onSalir: () => void;
}) {
  const id = useId(),
    boton = useRef<HTMLButtonElement>(null),
    menu = useRef<HTMLDivElement>(null),
    [abierto, setAbierto] = useState(false);
  useEffect(() => {
    const el = menu.current;
    if (!el) return;
    // Se ancla bajo el botón; la barra es sticky, así que su posición en
    // pantalla no cambia con el scroll mientras el menú está abierto.
    function onToggle(e: Event) {
      const open = (e as ToggleEvent).newState === "open";
      setAbierto(open);
      if (!open || !boton.current || !el) return;
      const r = boton.current.getBoundingClientRect();
      el.style.top = `${r.bottom + 6}px`;
      el.style.right = `${Math.max(8, window.innerWidth - r.right)}px`;
    }
    el.addEventListener("toggle", onToggle);
    return () => el.removeEventListener("toggle", onToggle);
  }, []);
  const elegir = (accion: () => void) => () => {
    menu.current?.hidePopover();
    accion();
  };
  const iniciales = nombre
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join("");
  return (
    <>
      <button
        ref={boton}
        className="cuenta-boton ghost"
        popoverTarget={id}
        aria-expanded={abierto}
        aria-label={`Cuenta de ${nombre}`}
      >
        <span className="avatar" aria-hidden="true">
          {iniciales}
        </span>
        <span className="cuenta-nombre">{nombre.split(/\s+/)[0]}</span>
        <Icono nombre="bajar" />
      </button>
      <div ref={menu} id={id} popover="auto" className="menu-cuenta">
        <p className="menu-titulo">
          <small>Sesión iniciada como</small>
          <strong>{nombre}</strong>
        </p>
        <button disabled={busy} onClick={elegir(onPerfil)}>
          <Icono nombre="usuario" /> Mi cuenta
        </button>
        <button disabled={busy} onClick={elegir(onPin)}>
          <Icono nombre="candado" /> Cambiar PIN
        </button>
        <hr />
        <button disabled={busy} onClick={elegir(onSalir)}>
          <Icono nombre="salir" /> Cambiar vendedor
        </button>
      </div>
    </>
  );
}
